/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digest_Turned_OnInputs */

const en_digest_turned_on = /** @type {(inputs: Digest_Turned_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You get the digest of your territories every Monday at 08:00.`)
};

/**
* | output |
* | --- |
* | "You get the digest of your territories every Monday at 08:00." |
*
* @param {Digest_Turned_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const digest_turned_on = /** @type {((inputs?: Digest_Turned_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digest_Turned_OnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_digest_turned_on(inputs)
});